var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    {
      directives: [
        {
          name: "animate-css",
          rawName: "v-animate-css",
          value: "fadeIn",
          expression: "'fadeIn'",
        },
      ],
      staticClass: "profileView",
    },
    [
      _c(
        "b-row",
        [
          _c("b-col", [
            _c("a", { staticClass: "button", attrs: { href: "/list" } }, [
              _vm._v("Back To List"),
            ]),
          ]),
          _vm._v(" "),
          _c("b-col", [
            _c(
              "div",
              { staticClass: "formTitle" },
              [
                _c("svg-image", { attrs: { image: "iconID" } }),
                _vm._v(" "),
                _c("h5", [_vm._v("Identity Update")]),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c("b-col"),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c("b-col", { staticClass: "updateForm" }, [
            !_vm.userProfile.profileComplete && !_vm.fileUploaded
              ? _c(
                  "div",
                  { attrs: { id: "step2" } },
                  [
                    _c("div", [
                      _c("img", {
                        staticClass: "idCard",
                        attrs: {
                          src:
                            "https://repository.race.id/view/" +
                            _vm.form.mbsdFile,
                        },
                      }),
                      _vm._v(" "),
                      _c("h3", [_vm._v(_vm._s(_vm.form.mbsdIDNumber))]),
                    ]),
                    _vm._v(" "),
                    _vm.form.mbsdStatus == 0
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mb-3",
                            attrs: { block: "", variant: "primary" },
                            on: {
                              click: function ($event) {
                                return _vm.verifyData(_vm.form)
                              },
                            },
                          },
                          [_vm._v("Approve Data")]
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.mbsdStatus == 0 || _vm.form.mbsdStatus == 1
                      ? _c(
                          "b-button",
                          {
                            staticClass: "mb-3",
                            attrs: { block: "", variant: "warning" },
                            on: {
                              click: function ($event) {
                                return _vm.updateProfile(_vm.form)
                              },
                            },
                          },
                          [_vm._v("Force Reject Data")]
                        )
                      : _vm._e(),
                  ],
                  1
                )
              : _vm._e(),
          ]),
          _vm._v(" "),
          _c("b-col", { staticClass: "updateForm" }, [
            _c(
              "div",
              { attrs: { id: "step3" } },
              [
                _c(
                  "b-form",
                  { on: { submit: _vm.onData } },
                  [
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "fullName-group",
                          label: "Full Name",
                          "label-for": "fullName",
                        },
                      },
                      [
                        _c("b-form-input", {
                          attrs: {
                            id: "fullName",
                            state: _vm.formStatus.mbsdIDNumber.state,
                            required: "",
                          },
                          model: {
                            value: _vm.form.mbsdFullName,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdFullName", $$v)
                            },
                            expression: "form.mbsdFullName",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "gender-group",
                          label: _vm.$t("signup.form.gender"),
                          "label-for": "gender",
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: {
                            id: "gender",
                            options: _vm.gender,
                            required: "",
                          },
                          model: {
                            value: _vm.form.mbsdGender,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdGender", $$v)
                            },
                            expression: "form.mbsdGender",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "birthDate-group",
                          label: _vm.$t("validate.data.doblabel"),
                          "label-for": "birthDate",
                        },
                      },
                      [
                        _c("datetime", {
                          attrs: {
                            id: "birthDate",
                            state: _vm.formStatus.mbsdBirthDate.state,
                            "max-datetime": "20061115",
                            "value-zone": "Asia/Jakarta",
                          },
                          model: {
                            value: _vm.form.mbsdBirthDate,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdBirthDate", $$v)
                            },
                            expression: "form.mbsdBirthDate",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "birthPlace-group",
                          label: _vm.$t("validate.data.poblabel"),
                          "label-for": "birthPlace",
                        },
                      },
                      [
                        _c("gmap-autocomplete", {
                          staticClass: "form-control",
                          attrs: {
                            id: "birthPlace",
                            state: _vm.formStatus.mbsdBirthPlace.state,
                            value: _vm.form.mbsdBirthPlace,
                            options: _vm.birthplaceOptions,
                            required: "",
                          },
                          on: { place_changed: _vm.setBirthPlace },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "bloodType-group",
                          label: _vm.$t("validate.data.blo"),
                          "label-for": "bloodType",
                        },
                      },
                      [
                        _c("b-form-select", {
                          attrs: {
                            id: "bloodType",
                            options: _vm.bloodType,
                            state: _vm.formStatus.mbsdBloodType.state,
                            required: "",
                          },
                          model: {
                            value: _vm.form.mbsdBloodType,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdBloodType", $$v)
                            },
                            expression: "form.mbsdBloodType",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "nationality-group",
                          label: _vm.$t("validate.data.nat"),
                          "label-for": "nationality",
                        },
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            state: _vm.formStatus.mbsdNationality.state,
                            options: _vm.countries,
                            label: "name",
                            reduce: (country) => country.code,
                          },
                          model: {
                            value: _vm.form.mbsdNationality,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdNationality", $$v)
                            },
                            expression: "form.mbsdNationality",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c(
                      "b-form-group",
                      {
                        attrs: {
                          id: "country-group",
                          label: _vm.$t("validate.data.cou"),
                          "label-for": "country",
                        },
                      },
                      [
                        _c("v-select", {
                          attrs: {
                            options: _vm.countries,
                            label: "name",
                            state: _vm.formStatus.mbsdCountry.state,
                            reduce: (country) => country.code,
                          },
                          on: { input: _vm.setCountryRestriction },
                          model: {
                            value: _vm.form.mbsdCountry,
                            callback: function ($$v) {
                              _vm.$set(_vm.form, "mbsdCountry", $$v)
                            },
                            expression: "form.mbsdCountry",
                          },
                        }),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.form.mbsdCountry && _vm.form.mbsdCountry == "ID"
                      ? _c(
                          "b-form-group",
                          {
                            staticClass: "addressForm",
                            attrs: {
                              id: "address-group",
                              label: _vm.$t("validate.data.dom"),
                              description: _vm.$t("validate.data.domdesc"),
                              "label-for": "address",
                            },
                          },
                          [
                            _c("b-form-input", {
                              staticClass: "mt-2",
                              attrs: {
                                placeholder: _vm.$t("validate.data.add"),
                              },
                              model: {
                                value: _vm.form.mbsdAddress,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mbsdAddress", $$v)
                                },
                                expression: "form.mbsdAddress",
                              },
                            }),
                            _vm._v(" "),
                            _c("v-select", {
                              staticClass: "mt-2",
                              attrs: {
                                options: _vm.fetchedOptions,
                                placeholder: _vm.$t("validate.data.cit"),
                                label: "label",
                              },
                              on: {
                                search: _vm.fetchOptions,
                                input: _vm.citySelected,
                              },
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "mt-2",
                              attrs: {
                                placeholder: _vm.$t("validate.data.pro"),
                                disabled: "",
                              },
                              model: {
                                value: _vm.form.mbsdProvinces,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mbsdProvinces", $$v)
                                },
                                expression: "form.mbsdProvinces",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.form.mbsdCountry && _vm.form.mbsdCountry != "ID"
                      ? _c(
                          "b-form-group",
                          {
                            attrs: {
                              id: "address-group",
                              label: _vm.$t("validate.data.dom"),
                              "label-for": "address",
                            },
                          },
                          [
                            _c("gmap-autocomplete", {
                              staticClass: "form-control",
                              attrs: {
                                id: "address",
                                value: _vm.form.mbsdAddress,
                                options: _vm.addressOptions,
                                state: _vm.formStatus.mbsdAddress.state,
                                required: "",
                                placeholder: "",
                              },
                              on: { place_changed: _vm.setAddress },
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "mt-2",
                              attrs: {
                                placeholder: _vm.$t("validate.data.cit"),
                                disabled: "",
                              },
                              model: {
                                value: _vm.form.mbsdCity,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mbsdCity", $$v)
                                },
                                expression: "form.mbsdCity",
                              },
                            }),
                            _vm._v(" "),
                            _c("b-form-input", {
                              staticClass: "mt-2",
                              attrs: {
                                placeholder: _vm.$t("validate.data.pro"),
                                disabled: "",
                              },
                              model: {
                                value: _vm.form.mbsdProvinces,
                                callback: function ($$v) {
                                  _vm.$set(_vm.form, "mbsdProvinces", $$v)
                                },
                                expression: "form.mbsdProvinces",
                              },
                            }),
                          ],
                          1
                        )
                      : _vm._e(),
                    _vm._v(" "),
                    _c("alert", { attrs: { status: _vm.status } }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "clearfix" },
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              block: "",
                              type: "submit",
                              variant: "primary",
                              size: "lg",
                              disabled: _vm.loading,
                            },
                          },
                          [
                            _vm.loading
                              ? _c("b-spinner", {
                                  attrs: { small: "", type: "grow" },
                                })
                              : _vm._e(),
                            _vm._v(" Update Member Data"),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


// WEBPACK FOOTER //
// src/views/ProfileUpdate.vue